var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-pic",style:(`background-image:url('${_vm.backgroundSrc}'); background-color: ${_vm.backgroundColor}`)})
}
var staticRenderFns = []

export { render, staticRenderFns }